import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { DigitalCouponService } from '../../../../services/api-appointment/digital-coupon/digital-coupon.service';
import { SpinnerService } from '../../../../services/spinner/spinner.service';

@Component({
  selector: 'app-digitalcoupon-view',
  templateUrl: './digitalcoupon-view.component.html',
  styleUrls: ['./digitalcoupon-view.component.css']
})
export class DigitalcouponViewComponent implements OnInit {

  id: number;
  goBackUrl: string = "/digitalcoupon/";
  view = {
    id: "",
    reservationDate: "",
    storeAddress: "",
    storeCity: "",
    storeComsy: "",
    storeId: "",
    email: "",
    name: "",
    surname: "",
    telephone: "",
    flgConsentCommMktgLead: null,
    pageUrl: ""
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private digitalCouponService: DigitalCouponService,
    private spinner: SpinnerService,
    private toastr: ToastrService,
  ) {
    this.id = this.route.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.loadDataByID(this.id);
  }


  loadDataByID(idObj) {
    this.spinner.show();
    this.digitalCouponService.getEntity(idObj).subscribe(
      (response) => {
        if (response) {
          this.setViewValue(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni', 'Caricamento informazioni', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }


  setViewValue(response) {
    for (let attr in this.view) {
      if (response[attr] != null && typeof response[attr] != typeof undefined) {
        this.view[attr] = response[attr];
      }
    }
  }


  clickButtonCancel() {
    //Torna indietro alla tabella
    this.router.navigate([this.goBackUrl]);
  }

}
